































































import {Component} from "vue-property-decorator";
import AbpBase from "@/lib/abpbase";
import {GetDocSzdt, GetPatDocs} from "@/api/hd";
import AddOrEdit from '../patient/parts/medDoc/parts/addOrEdit.vue'
import AddOrEditLlx from '../patient/parts/medDoc/parts/addOrEditLlx.vue'
import AddOrEditNlrs from '../patient/parts/medDoc/parts/addOrEditNlrs.vue'
import AddOrEditSjmbg from '../patient/parts/medDoc/parts/addOrEditSjmbg.vue'
import AddOrEditSjmzgrs from '../patient/parts/medDoc/parts/addOrEditSjmzgrs.vue'
import AddOrEditSjmzgszq from '../patient/parts/medDoc/parts/addOrEditSjmzgszq.vue'
import AddOrEditSdsdg from '../patient/parts/medDoc/parts/addOrEditSdsdg.vue'
import AddOrEditWgs from '../patient/parts/medDoc/parts/addOrEditWgs.vue'
import AddOrEditXygl from '../patient/parts/medDoc/parts/addOrEditXygl.vue'

@Component({
	components: {
		AddOrEdit, AddOrEditLlx, AddOrEditNlrs, AddOrEditSjmbg,AddOrEditXygl,
		AddOrEditSjmzgrs, AddOrEditSjmzgszq, AddOrEditSdsdg, AddOrEditWgs
	}
})
export default class Patient extends AbpBase {
	addOrEditShow: boolean = false
	addOrEditData: any = {}
	addOrEditLlxShow: boolean = false
	addOrEditNlrsShow: boolean = false
	addOrEditSjmbgShow: boolean = false
	addOrEditSjmzgShow: boolean = false
	addOrEditSjmzgszqShow: boolean = false
	addOrEditSdsdgShow: boolean = false
	addOrEditWgsShow: boolean = false
	addOrEditXyglShow: boolean = false
	type = '0'
	showCompleted = true
	loading = true
	data: any = []
	rightCompletedData: any = []
	rightUnCompletedData: any = []
	title = ''
	patientCopy: any = {}
	leftColumns = [
		{
			title: '文书类型',
			key: 'docType',

		},
		// {
		// 	title: '总数量',
		// 	width: 130,
		// 	key: 'docType',
		// 	render: (h: any, params: any) => {
		// 		return h('div',
		// 			{
		// 				style: {
		// 					textAlign: 'center'
		// 				}
		// 			},
		// 			Number(params.row.completedCount) + Number(params.row.unCompletedCount))
		// 	}
		//
		// },
		{
			title: '已存在文书',
			width: 130,
			render: (h: any, params: any) => {
				const _this = this
				return h('div', {
					style: {
						color: 'blue',
						textAlign: 'center',
						cursor: 'pointer'
					},
					on: {
						click: () => {
							_this.selectTable(true, params.row)
						}
					}
				}, params.row.completedCount)
			}
		}, {
			title: '不存在文书',
			key: 'unCompletedCount',
			width: 130,
			render: (h: any, params: any) => {
				let _this = this
				return h('div', {
					style: {
						color: 'blue',
						textAlign: 'center',
						cursor: 'pointer'
					},
					on: {
						click: () => {
							_this.selectTable(false, params.row)

						}
					}
				}, params.row.unCompletedCount)
			}
		}
	]
	rightColumnsCompleted = [
		{
			title: '姓名',
			key: 'patientName',

		},
		{
			title: '创建时间',
			key: 'patientName',
			render: (h: any, p: any) => {
				return h('span', this.formatDate(p.row.creationTime))
			}

		}, {
			title: '操作',
			render: (h: any, params: any) => {
				let _this = this
				return h('div', [
					h('Button', {
						props: {
							type: 'primary'
						},
						on: {
							click: () => {
								this.show(params.row.docType, params.row.patientId, params.row.id)
							}
						}
					}, '查看')
				])
			}
		}
	]
	rightColumnsUnCompleted = [
		{
			title: '姓名',
			key: 'patientName',

		}, {
			title: '操作',
			render: (h: any, params: any) => {
				let _this = this
				return h('div', [
					h('Button', {
						props: {
							type: 'primary'
						},
						on: {
							click: () => {
								this.addOne(params.row.docType, params.row.patientId)
							}
						}
					}, '新增')
				])
			}
		}
	]

	async addOne(name: string, patientId: number) {
		await this.getPatientDetail(patientId)
		const _this = this
		switch (name) {
			case '动静脉内瘘成形术知情同意书':
				this.addOrEditData = {
					mode: 'add',
					name: name,
					patient: _this.patientCopy
				}
				this.addOrEditShow = true
				break
			case '连续性肾脏替代治疗同意书':
				this.addOrEditData = {
					mode: 'add',
					name: name,
					patient: _this.patientCopy
				}
				this.addOrEditLlxShow = true
				break
			case '内瘘溶栓同意书':
				this.addOrEditData = {
					mode: 'add',
					name: name,
					patient: _this.patientCopy
				}
				this.addOrEditNlrsShow = true
				break
			case '深静脉拔管同意书':
				this.addOrEditData = {
					mode: 'add',
					name: name,
					patient: _this.patientCopy
				}
				this.addOrEditSjmbgShow = true
				break
			case '深静脉置管溶栓同意书':
				this.addOrEditData = {
					mode: 'add',
					name: name,
					patient: _this.patientCopy
				}
				this.addOrEditSjmzgShow = true
				break
			case '深静脉置管术知情同意书':
				this.addOrEditData = {
					mode: 'add',
					name: name,
					patient: _this.patientCopy
				}
				this.addOrEditSjmzgszqShow = true
				break
			case '隧道式导管知情同意书':
				this.addOrEditData = {
					mode: 'add',
					name: name,
					patient: _this.patientCopy
				}
				this.addOrEditSdsdgShow = true
				break
			case '无肝素透析知情同意书':
				this.addOrEditData = {
					mode: 'add',
					name: name,
					patient: _this.patientCopy
				}
				this.addOrEditWgsShow = true
				break
			case '血液灌流知情同意书':
				this.addOrEditData = {
					mode: 'add',
					name: name,
					patient: _this.patientCopy
				}
				this.addOrEditXyglShow = true
				break
		}

	}

	async show(name: string, patientId: number, itemId: number) {
		await this.getPatientDetail(patientId)
		const _this = this
		switch (name) {
			case '动静脉内瘘成形术知情同意书':
				this.addOrEditData = {
					id: itemId,
					mode: 'show',
					name: name,
					patient: _this.patientCopy
				}
				this.addOrEditShow = true
				break
			case '连续性肾脏替代治疗同意书':
				this.addOrEditData = {
					id: itemId,
					mode: 'show',
					name: name,
					patient: _this.patientCopy
				}
				this.addOrEditLlxShow = true
				break
			case '内瘘溶栓同意书':
				this.addOrEditData = {
					id: itemId,
					mode: 'show',
					name: name,
					patient: _this.patientCopy
				}
				this.addOrEditNlrsShow = true
				break
			case '深静脉拔管同意书':
				this.addOrEditData = {
					id: itemId,
					mode: 'show',
					name: name,
					patient: _this.patientCopy
				}
				this.addOrEditSjmbgShow = true
				break
			case '深静脉置管溶栓同意书':
				this.addOrEditData = {
					id: itemId,
					mode: 'show',
					name: name,
					patient: _this.patientCopy
				}
				this.addOrEditSjmzgShow = true
				break
			case '深静脉置管术知情同意书':
				this.addOrEditData = {
					id: itemId,
					mode: 'show',
					name: name,
					patient: _this.patientCopy
				}
				this.addOrEditSjmzgszqShow = true
				break
			case '隧道式导管知情同意书':
				this.addOrEditData = {
					id: itemId,
					mode: 'show',
					name: name,
					patient: _this.patientCopy
				}
				this.addOrEditSdsdgShow = true
				break
			case '无肝素透析知情同意书':
				this.addOrEditData = {
					id: itemId,
					mode: 'show',
					name: name,
					patient: _this.patientCopy
				}
				this.addOrEditWgsShow = true
				break
			case '血液灌流知情同意书':
				this.addOrEditData = {
					id: itemId,
					mode: 'show',
					name: name,
					patient: _this.patientCopy
				}
				this.addOrEditXyglShow = true
				break
		}
	}

	saveSuccess() {
		this.init()
		this.addOrEditShow = false
		this.addOrEditLlxShow = false
		this.addOrEditNlrsShow = false
		this.addOrEditSjmbgShow = false
		this.addOrEditSjmzgShow = false
		this.addOrEditSjmzgszqShow = false
		this.addOrEditSdsdgShow = false
		this.addOrEditWgsShow = false
		this.addOrEditXyglShow = false
	}

	created() {
		this.init()
	}

	selectTable(show: boolean, row: any) {
		this.showCompleted = show
		this.rightCompletedData = row.completedItems
		this.rightUnCompletedData = row.unCompletedItems
		this.title = row.docType + (show ? '已完成' : '未完成')
	}

	private async init() {
		this.loading = true
		let res = await GetPatDocs({type: this.type})
		this.data = res.objects
		console.log(this.data)
		this.rightCompletedData = this.data[0].completedItems
		this.rightUnCompletedData = this.data[0].unCompletedItems
		this.title = this.data[0].docType + '已完成'
		this.loading = false
	}

	async getPatientDetail(id: any) {
		let res = await GetDocSzdt({PatientId: id})
		this.patientCopy = {...res.objects.patient, id:id}
	}
}



// WEBPACK FOOTER //
// ./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/views/electronicMedicalRecord/docManage/index.vue